import React, { Component } from "react";
import { Grid } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class PlatformGuidelines extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
        <Grid className="with-background about-us-page">
          <Banner heading="Platform Guildlines" />
            <iframe src="https://drive.google.com/file/d/15tRqvcMmVJ3kBz9FgbZa3YoiSpB5wRef/preview" className="platform-guildlines"  title="Platform Guildlines"></iframe>
        </Grid>
      </Header>
    );
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/PlatformGuidelines.jsx.erb